
import {
  UserGroupIcon,
  Squares2X2Icon,
  ChartBarIcon,
  ClipboardDocumentListIcon,
  AcademicCapIcon,
  BookOpenIcon,
  CalculatorIcon,
  BeakerIcon,
} from "@heroicons/react/24/outline";



export const statsData = [
  {
    id: 1,
    title: "My class Progress",
    value: "Quick Analytic Overview",
    icon: UserGroupIcon,
    arrowColor: "text-blue-600",
    link: "/progressbar",
    onclick: 'false'
  },

  {
    id: 2,
    title: "My Applications",
    value: "Teaching tools & resources",
    icon: Squares2X2Icon,
    arrowColor: "text-green-600",
    link: "/educatorapplications",
    onclick: 'false'
  },
  {
    id: 3,
    title: "Add Notes & Grades",
    value: "Student assessment entry",
    icon: ClipboardDocumentListIcon,
    arrowColor: "text-orange-600",
    link: "/addnotesgrades",
    onclick: 'false'
  },
  {
    id: 4,
    title: "Student Management",
    value: "Enroll & Manage Student",
    icon: AcademicCapIcon,
    arrowColor: "text-green-600",
    link: "/studentmanagement",
    onclick: 'false'
  },
];





export const performanceData = [
  { week: "Week 1", avg: 78 },
  { week: "Week 2", avg: 82 },
  { week: "Week 3", avg: 85 },
  { week: "Week 4", avg: 89 },
];

export const students = [
  { id: 1, name: "Sarah Johnson", score: 96, status: "top", img: "https://randomuser.me/api/portraits/women/68.jpg" },
  { id: 2, name: "Sarah Johnson", score: 96, status: "top", img: "https://randomuser.me/api/portraits/women/69.jpg" },
  { id: 3, name: "Sarah Johnson", score: 96, status: "top", img: "https://randomuser.me/api/portraits/women/70.jpg" },
  { id: 4, name: "David Rodriguez", score: 66, status: "attention", img: "https://randomuser.me/api/portraits/men/71.jpg" },
  { id: 5, name: "Sophie Taylor", score: 36, status: "attention", img: "https://randomuser.me/api/portraits/women/72.jpg" },
];


export const usageData = [
  {
    id: 1,
    title: "Reading Comprehension",
    students: 24,
    completion: 85,
    iconColor: "text-green-500",
    barColor: "bg-green-500",
    bgColor: "bg-green-100",
    icon: BookOpenIcon,
  },
  {
    id: 2,
    title: "Math Practice",
    students: 24,
    completion: 85,
    iconColor: "text-yellow-500",
    barColor: "bg-yellow-500",
    bgColor: "bg-yellow-100",
    icon: Squares2X2Icon,
  },
  {
    id: 3,
    title: "Science Explorer",
    students: 64,
    completion: 95,
    iconColor: "text-orange-500",
    barColor: "bg-orange-500",
    bgColor: "bg-orange-100",
    icon: BeakerIcon,
  },
];

export const filterConfigs = [
  { key: "apps", label: "All Applications", options: ["Math App", "Science App", "English App"], color: "blue" },
  { key: "grades", label: "All Grades", options: ["Grade 1", "Grade 2", "Grade 3"], color: "green" },
  { key: "status", label: "All Status", options: ["Active", "Inactive", "Pending"], color: "purple" },
  { key: "adoption", label: "All Adoption Levels", options: ["Low", "Medium", "High"], color: "orange" },
];

